/** @jsx jsx */
import { jsx, Flex } from "theme-ui"

import Container from "../grid/container"
import Menu from "components/menu"

import useLocales from "hooks/use-locales"

const Header = () => {
  const { Switcher } = useLocales()
  return (
    <header sx={{ position: "fixed", top: 0, width: "100%", zIndex: 999 }}>
      <Container>
        <Flex sx={{ width: "100%", justifyContent: "flex-end", py: 4 }}>
          <Switcher sx={{ mr: 3 }} />
          <Menu />
        </Flex>
      </Container>
    </header>
  )
}

export default Header
